export function customSelect() {
    let parentSelector = "[class~=\"grid\"], [class*=\"grid-\"], [class*=\"grid_\"]";

    $.each($("select.form-control"), function (index, _item) {
        let
            item = $(_item).addClass("init-select"),
            par = item.closest(".form-item"),
            placeholder = item.data("placeholder"),
            params = {
                allowClear: true,
                dropdownParent: par
            };

        if (placeholder) {
            params.placeholder = placeholder;
        }

        item.select2(params).on("select2:open", function () {
            par.addClass("focus");
            $(this).closest($(parentSelector)).addClass("parent-select");

        }).on("select2:close", function () {
            let _this = $(this);

            if (!_this.val()) {
                par.removeClass("focus");
            }

            _this.closest($(parentSelector)).removeClass("parent-select");
        });
    });

    $(".form-item.wrap-select").on("click", "label", function (e) {
        e.preventDefault();

        let
            curWrap = $(e.delegateTarget),
            select = curWrap.find("select");

        if (!select.data("isOpenSelect")) {
            select.select2("open");
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js